import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useParams } from 'react-router-dom'
import '../css/product.css'
import helpers from '../helper';
import Loadingpage from '../loader/Cms';
import ProductLoader from '../loader/Product';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js';


export default function Productdetail() {

    Fancybox.bind('[data-fancybox="gallery"]', {});
    Fancybox.bind('[data-fancybox="p-gallery"]', {});
    let params = useParams();
    const [pageloader, setPageloader] = useState(false);
    const [proloader, setProloader] = useState(false);
    const [gellloader, setGellloader] = useState(false);
    const [pagedata, setPagedata] = useState();
    const [productslists, setProductLists] = useState([]);

    const [btnloader, setBtnloader] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [error, setError] = useState({ name: "", email: "", phone: "" });


    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/products/' + params.alias)
                .then((response) => {

                    setPagedata(response.data.result);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [params]);

    useEffect(() => {
        setProloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/products?datatype=topproducts')
                .then((response) => {
                    setProductLists(response.data.result.data);
                    setProloader(false);
                });
        }
        fetchData();
    }, [setProductLists]);

    useEffect(() => {
        setGellloader(false);
    },);

    async function QuoteRequest(e) {
        e.preventDefault();
        setBtnloader(true);
        setError({ name: "", email: "", phone: "" });
        let callback = { name: name, email: email, phone: phone, product: pagedata.id }
        await axios.post(process.env.REACT_APP_API + 'api/quoterequest', callback)
            .then((response) => {
                toast.success(response.data.message);
                setBtnloader(false);
                setName("");
                setEmail("");
                setPhone("");
            })
            .catch((errors) => {
                if (errors.response !== undefined) {
                    let rterror = errors.response.data.errors;
                    setError({
                        name: rterror.name,
                        email: rterror.email,
                        phone: rterror.phone
                    });
                    setBtnloader(false);
                }
            });
    }

    return (
        <>
            <Helmet>
                <title>{pagedata ? pagedata.meta_title : 'This product is not available yet.'}</title>
                <meta name="description" content={pagedata ? pagedata.meta_description : ''} />
                <meta name="keywords" content={pagedata ? pagedata.meta_keywords : ''} />
            </Helmet>
            <main>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Product Name" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">{pagedata ? pagedata.title : ''}</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><Link to={pagedata?.category_info ? "/category/" + pagedata?.category_info?.alias : "products"}>{pagedata?.category_info ? pagedata?.category_info?.name : 'Products'}</Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">{pagedata ? pagedata.title : ''}</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                {
                    pageloader ?
                        <Loadingpage />
                        :
                        pagedata ?
                            <section>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <div className="mb-4 me-lg-4 ProImgBox" id="ProImgBox">
                                                {
                                                    helpers.helpers1(pagedata.image) ?
                                                        <div data-thumb-src={process.env.REACT_APP_API + 'uploads/product/' + pagedata.image}>
                                                            <a href={process.env.REACT_APP_API + 'uploads/product/' + pagedata.image} data-fancybox="gallery" className="gallery h-auto">
                                                                <picture className="img">
                                                                    <img data-lazy-src={process.env.REACT_APP_IMAGE + 'uploads/product/' + pagedata.image} src={process.env.REACT_APP_API + 'uploads/product/' + pagedata.image} alt={pagedata.title} className="w-100" width="900" height="900" />
                                                                </picture>
                                                            </a>
                                                        </div>
                                                        :
                                                        <div data-thumb-src={process.env.REACT_APP_IMAGE + 'uploads/product/jpg/' + pagedata.image + '.jpg'}>
                                                            <a href={process.env.REACT_APP_IMAGE + 'uploads/product/jpg/' + pagedata.image + '.jpg'} data-fancybox="gallery" className="gallery h-auto">
                                                                <picture className="img">
                                                                    <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/product/webp/' + pagedata.image + '.webp'} type="image/webp" />
                                                                    <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/product/avif/' + pagedata.image + '.avif'} type="image/avif" />
                                                                    <img data-lazy-src={process.env.REACT_APP_IMAGE + 'uploads/product/jpg/' + pagedata.image + '.jpg'} src={process.env.REACT_APP_API + 'uploads/product/' + pagedata.image} alt={pagedata.title} className="w-100" width="900" height="900" />
                                                                </picture>
                                                            </a>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-lg-7">
                                            <h2 className="thm">{pagedata.title}</h2>
                                            <div className="CmsPage" dangerouslySetInnerHTML={{ __html: pagedata.description }} />
                                            <div className="p-3 py-2 mt-4 text-end border-top border-bottom bg-secondary bg-opacity-10">
                                                <a data-bs-toggle="modal" href="#EnForm" className="btn btn-thm m-0"><span>Request a Quote</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            :
                            ''
                }
                {
                    gellloader ?
                        <ProductLoader />
                        :
                        pagedata?.gallery?.length > 0 && (
                            <section className='grey'>
                                <div className="container">
                                    <div className="text-center">
                                        <h2 className="Heading">Product <strong>Gallery</strong></h2>
                                    </div>
                                    <div className="row">
                                        {
                                            pagedata?.gallery?.map((gallery, index) => (
                                                <div className="col-xl-2 col-md-3 lg-sm-4 col-6" key={index}>
                                                    {
                                                        helpers.helpers1(pagedata.image) ?
                                                            <a href={process.env.REACT_APP_API + 'uploads/product/gallery/' + gallery.image} data-fancybox="p-gallery" data-caption={gallery?.title}>
                                                                <div className="gallery h-auto ImageG mb-0">
                                                                    <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/product/gallery/' + gallery.image} width="250" height="57" className="w-100" alt="PES Installations" />
                                                                </div>
                                                                <small className='p-0 lh-sm text-center d-block fw-semibold'>{gallery?.title}</small>
                                                            </a>
                                                            :
                                                            <a href={process.env.REACT_APP_IMAGE + 'uploads/product/gallery/jpg/' + gallery.image + '.jpg'} data-fancybox="p-gallery" data-caption={gallery?.title}>
                                                                <div className="gallery h-auto ImageG mb-0">
                                                                    <picture className="img">
                                                                        <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/product/gallery/webp/' + gallery.image + '.webp'} type="image/webp" />
                                                                        <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/product/gallery/avif/' + gallery.image + '.avif'} type="image/avif" />
                                                                        <img data-lazy-src={process.env.REACT_APP_IMAGE + 'uploads/product/gallery/jpg/' + gallery.image + '.jpg'} src={process.env.REACT_APP_API + 'uploads/product/gallery/' + gallery.image} alt={pagedata.title} width="250" height="57" className="w-100" />
                                                                    </picture>
                                                                </div>
                                                                <small className='p-0 lh-sm text-center d-block fw-semibold'>{gallery?.title}</small>
                                                            </a>
                                                    }

                                                </div>
                                            ))
                                        }


                                    </div>
                                </div>
                            </section>
                        )
                }
                {
                    proloader ?
                        <ProductLoader />
                        :
                        productslists.length > 0 ?
                            <section className="ProSec MyCarouselSec">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-12">
                                            <h2 className="Heading">Other <strong>Product</strong></h2>
                                        </div>
                                    </div>
                                    <OwlCarousel items={4} loop={false} autoplay={true} nav margin={20} className="MyCarousel" responsive={{ 0: { items: 1 }, 350: { items: 1 }, 460: { items: 2 }, 600: { items: 2 }, 768: { items: 3 }, 992: { items: 3 }, 1200: { items: 4 }, 1600: { items: 4 } }}>
                                        {
                                            productslists.map((product, p) =>
                                                <Link to={"/product/" + product.alias} key={p} className="card ProBlock CarBlock" onClick={() => this.render()}>
                                                    <div className="card-header">
                                                        {
                                                            helpers.helpers1(product.image) ?
                                                                <picture className="img">
                                                                    <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/product/' + product.image} alt={product.title} width="121" height="131" />
                                                                </picture>
                                                                :
                                                                <picture className="img">
                                                                    <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/product/webp/' + product.image + '.webp'} type="image/webp" />
                                                                    <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/product/avif/' + product.image + '.avif'} type="image/avif" />
                                                                    <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/product/jpg/' + product.image + '.jpg'} alt={product.title} width="121" height="131" />
                                                                </picture>
                                                        }
                                                    </div>
                                                    <div className="card-body text-center">
                                                        <h3>{product.title}</h3>
                                                        <span className="p-2 rounded-circle"><img src={require("../assets/img/arrow1.svg").default} height="18" width="18" alt="Product Name" /></span>
                                                    </div>
                                                </Link>
                                            )
                                        }


                                    </OwlCarousel>
                                    <div className="text-center"><Link to="/products" className="btn btn-thm">View all Product <img src={require("../assets/img/arrow1-w.svg").default} width="24" height="24" alt="arrow" /></Link></div>
                                </div>
                            </section>
                            :
                            ''
                }

            </main>

            <div className="modal fade PopupM" id="EnForm" tabIndex="-1" aria-labelledby="CareerFormLabel" aria-hidden="true">
                <div className="modal-dialog modal-md">
                    <form className="modal-content Quotefrm" onSubmit={QuoteRequest}>
                        <div className="modal-header border-0 d-none">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body pt-5 px-md-5">
                            <h3 className="fw-bold text-center h4 thm">Request a Quote</h3>
                            <p>Fill out the form below and apply for quotation
                                {pagedata ? <b className='ms-2'>“{pagedata.title}”</b> : ''} .
                            </p>
                            <div className="row">
                                <div className="col-12 col-md-12">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} id="name" placeholder="Name" />
                                        <label htmlFor="name" className="form-label">Name<span className="text-danger">*</span></label>
                                        {error.name ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.name}</span> : ''}
                                    </div>
                                </div>
                                <div className="col-12 col-md-12">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email Address" />
                                        <label htmlFor="email" className="form-label">Email Address<span className="text-danger">*</span></label>
                                        {error.email ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.email}</span> : ''}
                                    </div>
                                </div>
                                <div className="col-12 col-md-12">
                                    <div className="form-floating mb-3">
                                        <input type="number" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} id="mobile" placeholder="Contact Number" />
                                        <label htmlFor="mobile" className="form-label">Contact Number<span className="text-danger">*</span></label>
                                        {error.phone ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.phone}</span> : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer pt-4 border-top pb-5 d-block text-center">
                            {
                                btnloader ?
                                    <button type="button" className="btn btn-thm disabled"><FontAwesomeIcon icon={faSpinner} className="fa-spin me-1" /> Loading...</button>
                                    :
                                    <button className="btn btn-thm">Submit Application</button>
                            }
                            <button type="button" className="btn btn-thm1" data-bs-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
